'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeStateChangeListener = exports.addStateChangeListener = exports.updateState = exports.getState = exports.State = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _fallbackApi = require('../data/dev/fallbackApi');

var _fallbackApi2 = _interopRequireDefault(_fallbackApi);

var _fallbackConfig = require('../data/dev/fallbackConfig');

var _fallbackConfig2 = _interopRequireDefault(_fallbackConfig);

var _fallbackApi3 = require('../data/prod/fallbackApi');

var _fallbackApi4 = _interopRequireDefault(_fallbackApi3);

var _fallbackConfig3 = require('../data/prod/fallbackConfig');

var _fallbackConfig4 = _interopRequireDefault(_fallbackConfig3);

var _logger = require('../logging/logger');

var _logger2 = _interopRequireDefault(_logger);

var _constants = require('../logging/constants');

var _parseUtils = require('./parseUtils');

var _parseUtils2 = _interopRequireDefault(_parseUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var fallbacks = {
  fallbackApi: _fallbackApi2.default,
  fallbackConfig: _fallbackConfig2.default
};

var emitter = new _events2.default();

var myState = {
  isInitialized: false,
  tabFocus: true
};

var applicationState = {
  init: function init() {
    var _extends2,
        _extends3,
        _this = this;

    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (settings.env === 'production') {
      fallbacks.fallbackApi = _fallbackApi4.default;
      fallbacks.fallbackConfig = _fallbackConfig4.default;
    }

    var api = settings.api;
    if (!api) {
      _logger2.default.info({ message: _constants.FALLBACK_API_USED });
      api = fallbacks.fallbackApi;
    }

    var config = settings.config;
    if (!config) {
      _logger2.default.info({ message: _constants.FALLBACK_CONFIG_USED });
      config = fallbacks.fallbackConfig;
    }

    this.updateUnlockDetails(settings.unlock);

    var allSettings = _extends((_extends2 = {}, _defineProperty(_extends2, this.State.api, api), _defineProperty(_extends2, this.State.config, config), _defineProperty(_extends2, this.State.isInitialized, true), _defineProperty(_extends2, this.State.isPlayingVideoPreroll, false), _defineProperty(_extends2, this.State.isPrerollPlayerMinimized, false), _defineProperty(_extends2, this.State.positionInfo, {}), _defineProperty(_extends2, this.State.videoPrerollPlayed, false), _defineProperty(_extends2, this.State.dfpParams, {}), _extends2), settings, (_extends3 = {}, _defineProperty(_extends3, this.State.assetLocation, settings.assetLocation || '/'), _defineProperty(_extends3, this.State.firstVisitTime, settings.isFirstVisit ? Date.now() : 0), _defineProperty(_extends3, this.State.isMobile, settings.isMobile || false), _defineProperty(_extends3, this.State.partnerId, settings.partnerId || 'RadioTime'), _extends3));

    // apply all settings to state
    (0, _forEach2.default)(allSettings, function (value, setting) {
      myState[_this.State[setting]] = value;
    });

    while (this.stateUpdateQueue.length) {
      var _dequeueStateUpdate = this.dequeueStateUpdate(),
          _dequeueStateUpdate2 = _slicedToArray(_dequeueStateUpdate, 2),
          stateName = _dequeueStateUpdate2[0],
          value = _dequeueStateUpdate2[1];

      this.updateState(stateName, value);
    }

    // initialize focus monitoring
    this.setAppVisibilityEventListeners();
  },
  setAppVisibilityEventListeners: function setAppVisibilityEventListeners() {
    var _this2 = this;

    var options = this.get(this.State.options, {});
    var isSlotVisibilityExperimentEnabled = _parseUtils2.default.parseBool((0, _get2.default)(options, 'ads.pauseRefresh.enabled'));

    if (isSlotVisibilityExperimentEnabled) {
      return;
    }

    window.addEventListener('focus', function () {
      _this2.updateState(_this2.State.tabFocus, true);
    });

    window.addEventListener('blur', function () {
      _this2.updateState(_this2.State.tabFocus, false);
    });
  },

  get: function get(stateName, defaultValue) {
    var stateValue = myState[stateName];
    return !(0, _isUndefined2.default)(stateValue) ? stateValue : defaultValue;
  },
  addStateChangeListener: function addStateChangeListener(stateName, callback) {
    var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (once) {
      emitter.once(stateName, callback);
    } else {
      emitter.on(stateName, callback);
    }
  },
  removeStateChangeListener: function removeStateChangeListener(stateName, callback) {
    emitter.off(stateName, callback);
  },
  updateState: function updateState(stateName, value) {
    if (!myState.isInitialized) {
      this.enqueueStateUpdate([stateName, value]);
      return;
    }

    var prevValue = myState[stateName];

    if (!(0, _reactFastCompare2.default)(prevValue, value)) {
      myState[stateName] = value;
      emitter.emit(stateName, value, prevValue);
    }
  },
  updateUnlockDetails: function updateUnlockDetails(unlock) {
    if (unlock && unlock.SecondsRemaining) {
      var endDate = new Date();
      endDate.setSeconds(endDate.getSeconds() + unlock.SecondsRemaining);
      unlock.EndDate = JSON.stringify(endDate).replace(/"/g, '');
    }
    this.updateState(this.State.unlockDetails, unlock);
  },
  State: {
    volume: 'volume',
    config: 'config',
    api: 'api',
    env: 'env',
    options: 'options',
    unlock: 'unlock',
    nowPlaying: 'nowPlaying',
    profiles: 'profiles',
    rtid: 'rtid',
    isMobile: 'isMobile',
    username: 'username',
    isRegisteredUser: 'isRegisteredUser',
    playerStatus: 'playerStatus',
    positionInfo: 'positionInfo',
    tabFocus: 'tabFocus',
    isInitialized: 'isInitialized',
    selectedGuideId: 'selectedGuideId',
    currentScreen: 'currentScreen',
    lotamesegments: 'lotamesegments',
    subscriptionStatus: 'subscriptionStatus',
    version: 'version',
    desktopVersion: 'desktopVersion',
    assetLocation: 'assetLocation',
    onPremiumUnlockEvent: 'onPremiumUnlockEvent',
    unlockDetails: 'unlockDetails',
    language: 'language',
    countryRegionId: 'countryRegionId',
    stationLanguage: 'stationLanguage',
    isFirstVisit: 'isFirstVisit',
    firstVisitTime: 'firstVisitTime',
    isFirstInSession: 'isFirstInSession',
    categoryId: 'categoryId',
    tuneRequested: 'tuneRequested',
    isScreenBigEnoughForVideoAds: 'isScreenBigEnoughForVideoAds',
    lotameSegmentLimit: 'lotameSegmentLimit',
    gdprData: 'gdprData',
    adsEnabled: 'adsEnabled',
    isPrerollPlayerMinimized: 'isPrerollPlayerMinimized',
    isPlayingVideoPreroll: 'isPlayingVideoPreroll',
    videoPrerollPlayed: 'videoPrerollPlayed',
    partnerId: 'partnerId',
    inStreamAdInProgress: 'inStreamAdInProgress',
    prerollAdId: 'prerollAdId',
    prerollCreativeId: 'prerollCreativeId',
    ccpaStatus: 'ccpaStatus',
    ppid: 'ppid',
    ipAddress: 'ipAddress',
    isOptedOut: 'isOptedOut',
    dfpParams: 'dfpParams'
  },
  stateUpdateQueue: [],
  enqueueStateUpdate: function enqueueStateUpdate(v) {
    this.stateUpdateQueue.push(v);
  },
  dequeueStateUpdate: function dequeueStateUpdate() {
    return this.stateUpdateQueue.shift();
  }
};

var State = exports.State = applicationState.State;
var getState = exports.getState = applicationState.get;
var updateState = exports.updateState = applicationState.updateState.bind(applicationState);
var addStateChangeListener = exports.addStateChangeListener = applicationState.addStateChangeListener;
var removeStateChangeListener = exports.removeStateChangeListener = applicationState.removeStateChangeListener;
exports.default = applicationState;